export const HELPER_TEXT = {
    promotion_name: 'Tuliskan nama untuk Consumer Promotion',
    promotion_scheme: 'Pilih skema yang akan digunakan',
    tfm_id: 'No. PM tidak boleh kosong',
    start_date: 'Pilih tanggal permulaan promo',
    end_date: 'Pilih tanggal berakhirnya promo',
};

export const PLACEHOLDER = {
    promotion_name: 'Tuliskan nama dari Consumer Promotion',
    promotion_scheme: 'Pilih skema 3%-8%',
    tfm_id: 'Ketik No. PM disini',
    date: 'Pilih Tanggal',
};

export const STATUS = {
    draft: 'draft',
    'waiting for approval': 'waiting for approval',
    planned: 'planned',
    reject: 'rejected',
    active: 'active',
    processing: 'active',
    'ready to claim': 'ready to claim',
    done: 'done',
};
